import { useContext } from 'react';
import { ToastContext } from '@/app/providers/ToastProvider';
import type { ToastContextValue } from '@/app/providers/ToastProvider';

export const useToast = (): ToastContextValue => {
  const context = useContext(ToastContext);
  if (!context) throw new Error('useToast must be used within ToastProvider');
  return context;
};
